import store from '../store/officialTopup';
import { pageType, viewPage } from '@plugins/biPoint/_configWebstoreV3';

const checkGameAndLogin = () => {
  return store.state.login.isLogin;
};

export default [
  {
    path: '/',
    name: 'home',
    meta: {
      pageName: pageType.homePage
    },
    component: () => import('@views/officialTopup/Home.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.homePage);
      next();
    }
  },
  {
    path: '/result',
    name: 'result',
    meta: {
      pageName: pageType.resultPage
    },
    component: () => import('@views/officialTopup/Result.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.resultPage);
      next();
    }
  },
  {
    path: '/mine',
    name: 'mine',
    meta: {
      pageName: pageType.Mine
    },
    component: () => import('@views/officialTopup/Mine.vue'),
    beforeEnter: (_to, _from, next) => {
      if (checkGameAndLogin()) {
        viewPage(pageType.Mine);
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/bank_info',
    name: 'bankInfo',
    meta: {
      index: 3,
      pageName: pageType.bankPage
    },
    component: () => import('@views/officialTopup/BankDetailInfo.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.bankPage);
      next();
    }
  },
  {
    path: '/browserPay',
    name: 'browserPay',
    meta: {
      pageName: pageType.browserPay
    },
    component: () => import('@views/officialTopup/BrowserPaying.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.browserPay);
      next();
    }
  }
];
